import React, { useState, useRef } from 'react'
import { Button, BUTTON_SIZES } from 'shared/UI/Button'
import { useTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS } from 'shared/customHooks'
import isEmpty from 'lodash/isEmpty'
import PropTypes from 'prop-types'

const Password = (props) => {
  const { getTranslation } = useTranslation(TRANSLATION_KEYS.passwordPage, props.locale)
  const [password, setPassword] = useState('')
  const passwordRef = useRef()

  const handlePasswordEnter = () => {
    setPassword(passwordRef.current.value)
  }

  const handlePasswordSubmit = () => {
    props.onPasswordSubmit(passwordRef.current.value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    props.onPasswordSubmit(passwordRef.current.value)
  }

  const colorStyle = (color)=>{
    return isEmpty(color) ? null : { color: color }
  }

  const { title , subtitle } = props.pageProperties

  return (
    <form
      className="password-content"
      onSubmit={handleSubmit}>
      <div style={{...colorStyle(title.color)}} className="info-text">{isEmpty(title.text) ? getTranslation(TRANSLATION_VALUE_KEYS.passwordPageTitle) : title.text}</div>
      <div style={{...colorStyle(subtitle.color)}} className="secondary-text">{isEmpty(subtitle.text) ? getTranslation(TRANSLATION_VALUE_KEYS.passwordPageDescription) : subtitle.text}</div>
      <input
        className="password-input"
        type="password"
        placeholder={getTranslation(TRANSLATION_VALUE_KEYS.enterPasswordPlaceholder)}
        ref={passwordRef}
        value={password}
        onChange={handlePasswordEnter} />
      {props.invalidPassword &&
      <div className="invalid-password-message">{getTranslation(TRANSLATION_VALUE_KEYS.wrongPassword)}</div>
        }
      <Button
        className="submit-password"
        onClick={handlePasswordSubmit}
        size={BUTTON_SIZES.small}>
        {getTranslation(TRANSLATION_VALUE_KEYS.verifyPassword)}
      </Button>
    </form>
  )
}

Password.propTypes = {
  onPasswordSubmit: PropTypes.func.isRequired,
  invalidPassword: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  pageProperties: PropTypes.object.isRequired
}

export default Password
